var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"mb-1 mb-sm-0 mr-0 mr-sm-1 mt-1 btn-sm-block",attrs:{"type":"submit","variant":"primary","disabled":_vm.btnDisabled}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }